import React from 'react';
import { createIcon } from '@chakra-ui/react';

const Google = createIcon({
  displayName: 'Google',
  viewBox: '0 0 20 20',
  path: (
    <>
      <path
        fill="#4280EF"
        d="M 19.761719 10.1875 C 19.761719 9.367188 19.695312 8.769531 19.550781 8.148438 L 10.195312 8.148438 L 10.195312 11.847656 L 15.6875 11.847656 C 15.574219 12.765625 14.976562 14.152344 13.648438 15.082031 L 13.628906 15.207031 L 16.589844 17.496094 L 16.792969 17.515625 C 18.675781 15.777344 19.761719 13.222656 19.761719 10.1875 "
      />
      <path
        fill="#34A353"
        d="M 10.195312 19.929688 C 12.886719 19.929688 15.144531 19.046875 16.792969 17.515625 L 13.648438 15.082031 C 12.808594 15.667969 11.679688 16.078125 10.195312 16.078125 C 7.558594 16.078125 5.324219 14.339844 4.523438 11.9375 L 4.410156 11.945312 L 1.332031 14.328125 L 1.292969 14.4375 C 2.929688 17.695312 6.296875 19.929688 10.195312 19.929688 "
      />
      <path
        fill="#F6B704"
        d="M 4.523438 11.9375 C 4.316406 11.316406 4.191406 10.652344 4.191406 9.964844 C 4.191406 9.277344 4.316406 8.613281 4.515625 7.996094 L 4.507812 7.863281 L 1.394531 5.445312 L 1.292969 5.492188 C 0.617188 6.84375 0.230469 8.359375 0.230469 9.964844 C 0.230469 11.570312 0.617188 13.089844 1.292969 14.4375 L 4.523438 11.9375 "
      />
      <path
        fill="#E54335"
        d="M 10.195312 3.851562 C 12.066406 3.851562 13.328125 4.660156 14.046875 5.335938 L 16.859375 2.589844 C 15.132812 0.984375 12.886719 0 10.195312 0 C 6.296875 0 2.929688 2.238281 1.292969 5.492188 L 4.515625 7.996094 C 5.324219 5.59375 7.558594 3.851562 10.195312 3.851562 "
      />
    </>
  ),
});

export default Google;
